import EquipamentoFiscalizacao from "./EquipamentoFiscalizacao";
import Municipio from "./Municipio";

class VigenciaLocalizacaoEquipamento {
    constructor(
        {
            id = null,
            equipamento_fiscalizacao_id = null,
            data_instalacao = null,
            uf = null,
            municipio_id = null,
            codigo_logradouro_pbh = null,
            tipo_logradouro_pbh = null,
            nome_logradouro_pbh = null,
            numero = null,
            id_endereco_geocoder_pbh = null,
            coordenada_x = null,
            coordenada_y = null,
            complemento = null,
            sentido_via = null,
            created_at = null,
            updated_at = null,
            deleted_at = null,
            usuario_id = null,

            //ORM
            equipamento_fiscalizacao = {},
            municipio = {},

        } = {}
    ) {
        this.id = id;
        this.equipamento_fiscalizacao_id = equipamento_fiscalizacao_id;
        this.data_instalacao = data_instalacao;
        this.uf = uf;
        this.municipio_id = municipio_id;
        this.codigo_logradouro_pbh = codigo_logradouro_pbh;
        this.tipo_logradouro_pbh = tipo_logradouro_pbh;
        this.nome_logradouro_pbh = nome_logradouro_pbh;
        this.numero = numero;
        this.id_endereco_geocoder_pbh = id_endereco_geocoder_pbh;
        this.coordenada_x = coordenada_x;
        this.coordenada_y = coordenada_y;
        this.complemento = complemento;
        this.sentido_via = sentido_via;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.deleted_at = deleted_at;
        this.usuario_id = usuario_id;

        //ORM
        this.equipamento_fiscalizacao = equipamento_fiscalizacao ? new EquipamentoFiscalizacao(equipamento_fiscalizacao) : new EquipamentoFiscalizacao();
        this.municipio = municipio ? new Municipio(municipio) : new Municipio();

    }
}

export default VigenciaLocalizacaoEquipamento;